document.addEventListener('DOMContentLoaded', function () {
	const btn = document.querySelector('.js-HeroVideo');
	const video = document.querySelector('.hero__video video');

	btn.addEventListener('click', function () {
		video.muted = !video.muted;
		btn.textContent = video.muted ? 'Sound on' : 'Sound off';
	});
});
